import { configureStore } from '@reduxjs/toolkit';
import preferThemeReducer from 'redux/preferTheme/preferThemeSlice';
import usersReducer from 'redux/users/usersSlice';
import contactsReducer from 'redux/contacts/contactsSlice';
import languagesReducer from 'redux/contacts/languagesSlice';
import companiesReducer from 'redux/companies/companiesSlice';
import roleGroupsReducer from 'redux/roleGroups/roleGroupsSlice';
import appsReducer from 'redux/apps/appsSlice';
import contactTypesReducer from 'redux/contactTypes/contactTypesSlice';
import userMgtReducer from 'redux/userMgt/userMgtSlice';
import userInfoReducer from 'redux/userInfo/userInfoSlice';
import notificationBarReducer from 'redux/notificationBar/notificationBarSlice';
import uiReducer from 'redux/ui/uiSlice';
import enabledAppsReducer from 'redux/enabledApps/enabledAppsSlice';

const store = configureStore({
	reducer: {
		preferTheme: preferThemeReducer,
		users: usersReducer,
		contacts: contactsReducer,
		languages: languagesReducer,
		companies: companiesReducer,
		apps: appsReducer,
		roleGroups: roleGroupsReducer,
		contactTypes: contactTypesReducer,
		userMgt: userMgtReducer,
		notificationBar: notificationBarReducer,
		userInfo: userInfoReducer,
		ui: uiReducer,
		enabledApps: enabledAppsReducer,
	},
});

export default store;
